(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8891],{

/***/ 76957:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/theatres/[slug]",
      function () {
        return __webpack_require__(27795);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var components_DramoxImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20010);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62044);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99731);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17651);
/* harmony import */ var _typings_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81962);
/* harmony import */ var _AppLink_AppLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3245);







var CategorySectionFull = function(param) {
    var headline = param.headline, plays = param.plays, theatre = param.theatre, index = param.index;
    var ref = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_3__/* .Namespace.Common */ .l.Common), lang = ref.lang, t = ref.t;
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "category-section category-section-full ".concat(!index || index === 0 ? "first" : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "play-list-wrapper",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: headline
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "play-list",
                    children: plays === null || plays === void 0 ? void 0 : plays.map(function(play, i) {
                        var ref;
                        // onClick={() => playsGEvent(item.permalink)}
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                href: _helpers__WEBPACK_IMPORTED_MODULE_4__/* .Permalink.play */ .xm.play(play, lang),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    tabIndex: -1,
                                    children: [
                                        play.state === _typings_api__WEBPACK_IMPORTED_MODULE_5__/* .PlayState.PROMOTED */ .QT.PROMOTED ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "coming-soon",
                                            children: t("coming_soon")
                                        }) : null,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_DramoxImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            placeholderClass: "image-wrapper-for-playlist",
                                            src: play.poster_url,
                                            alt: play.title,
                                            width: 256,
                                            height: 144,
                                            quality: 90
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    children: (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .truncateTitle */ .ew)(play.title)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: (ref1 = play === null || play === void 0 ? void 0 : (ref = play.theatre) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : theatre
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategorySectionFull);


/***/ }),

/***/ 27795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52662);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28808);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62044);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3245);
/* harmony import */ var _components_CategorySections_CategorySectionFull__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60604);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46323);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99731);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17651);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70082);
/* harmony import */ var config_routeTable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82278);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56168);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(75332);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var constants_lang__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(74782);

// @ts-ignore














var TheatreDetail = function(param) {
    var theatre = param.theatre, countryCode = param.countryCode, isUserLoggedIn = param.isUserLoggedIn, canonical = param.canonical;
    var ref;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_8__/* .Namespace.Theaters */ .l.Theaters).t;
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_10__/* .useLang */ .J)().locale;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_13__.useRouter)();
    var ref1 = (0,context__WEBPACK_IMPORTED_MODULE_1__/* .useAuth */ .aC)(), user = ref1.user, isUserLoaded = ref1.isUserLoaded;
    var showDonateButton = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return (isUserLoggedIn || isUserLoaded && user) && (theatre === null || theatre === void 0 ? void 0 : theatre.donations_allowed);
    }, [
        isUserLoggedIn,
        isUserLoaded,
        user,
        theatre
    ]);
    var showRegisterButton = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return isUserLoaded && !isUserLoggedIn;
    }, [
        isUserLoaded,
        isUserLoggedIn
    ]);
    var structuredSEOData = (0,react__WEBPACK_IMPORTED_MODULE_12__.useMemo)(function() {
        return {
            "@context": "https://schema.org/",
            "@type": "EntertainmentBusiness",
            name: theatre.name,
            image: theatre.poster_url,
            url: "".concat((0,config_routeTable__WEBPACK_IMPORTED_MODULE_11__/* .baseUrl */ .F)(router.locale)).concat(router.asPath),
            sameAs: theatre.www_url ? [
                theatre.www_url
            ] : undefined
        };
    }, [
        theatre
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_2__/* .basicSEO */ .F)(t("seo:theatre_title", {
                        name: theatre.name
                    }), theatre.about, theatre.poster_url, undefined, true, canonical),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(structuredSEOData)
                        }
                    }),
                    constants_lang__WEBPACK_IMPORTED_MODULE_14__/* .locales.map */ .k1.map(function(langLocale) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "alternate",
                            href: "".concat((0,config_routeTable__WEBPACK_IMPORTED_MODULE_11__/* .baseUrl */ .F)(langLocale)).concat(helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.theatre */ .xm.theatre(theatre, langLocale)),
                            hrefLang: langLocale
                        }, langLocale);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "alternate",
                        href: "".concat((0,config_routeTable__WEBPACK_IMPORTED_MODULE_11__/* .baseUrl */ .F)("en")).concat(helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.theatre */ .xm.theatre(theatre, "en")),
                        hrefLang: "x-default"
                    }, "lang-default")
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "author-detail theater-detail",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "info-wrapper",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "image-placeholder",
                                children: (theatre === null || theatre === void 0 ? void 0 : theatre.poster_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: theatre === null || theatre === void 0 ? void 0 : theatre.poster_url,
                                    alt: theatre.name
                                }) : theatre === null || theatre === void 0 ? void 0 : (ref = theatre.name) === null || ref === void 0 ? void 0 : ref.substr(0, 1)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        children: theatre === null || theatre === void 0 ? void 0 : theatre.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "buttons",
                                        children: [
                                            showDonateButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                href: helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.donateTheatre */ .xm.donateTheatre(theatre, locale),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "btn btn-primary",
                                                    children: t("support")
                                                })
                                            }),
                                            showRegisterButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                href: helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.registerStep1 */ .xm.registerStep1(locale),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "btn btn-primary",
                                                    children: t("register")
                                                })
                                            }),
                                            (theatre === null || theatre === void 0 ? void 0 : theatre.www_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "btn btn-outline-info",
                                                href: theatre.www_url,
                                                rel: "external",
                                                target: "_blank",
                                                children: t("web_page")
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: theatre === null || theatre === void 0 ? void 0 : theatre.about
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CategorySections_CategorySectionFull__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        plays: theatre === null || theatre === void 0 ? void 0 : theatre.plays,
                        theatre: theatre === null || theatre === void 0 ? void 0 : theatre.name,
                        headline: t("theatre_plays")
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,context__WEBPACK_IMPORTED_MODULE_1__/* .withForcePlanToLoggedInUnsubs */ .DE)(TheatreDetail));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(76957); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);